import { httpMessage } from "@saleshub/dictionary/http";
import { z } from "zod";
import { withId } from "../../utils/with-id.js";
import { permissionsSchemaWithId } from "../permissions/permissions.schema.js";
export const rolesSchema = z.object({
    title: z.string({
        required_error: httpMessage.responses.roles.required.title,
        invalid_type_error: httpMessage.responses.roles.invalid.title,
    }),
    description: z.string({
        required_error: httpMessage.responses.roles.required.description,
        invalid_type_error: httpMessage.responses.roles.invalid.description,
    }),
    permissions: z.array(permissionsSchemaWithId).optional(),
});
export const rolesSchemaWithId = rolesSchema.merge(withId({
    required_error: httpMessage.responses.roles.required.id,
    invalid_type_error: httpMessage.responses.roles.invalid.id,
}));
